import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Scrollspy from "react-scrollspy"

const isActive = ({ isCurrent }) => {
  return isCurrent
    ? { className: "nav-link active" }
    : { className: "nav-link" }
}

const ExactNavLink = props => {
  return <Link getProps={isActive} {...props} />
}

const Navbar = ({ siteTitle, headerColor }) => {
  const [showNav, setShowNav] = React.useState(false)
  return (
    <nav className="navbar navbar-expand-md fixed-top" id="header">
      <div className="container">
        <Link to="/" className="navbar-brand" href="#">
          <StaticImage
            src="../images/logo-o.png"
            width={67}
            quality={100}
            alt={siteTitle}
            className="img-fluid"
          />
        </Link>

        <div className="d-none d-lg-block" id="main-navbar">
          <Scrollspy
            items={[
              "home-hero",
              "home-host-challenge",
              "home-play-superbetter",
            ]}
            currentClassName="active"
            offset={-120}
            className="navbar-nav me-auto mb-2 mb-md-0 w-100 d-flex align-items-center justify-content-start"
          >
            <li className="nav-item text-truncate">
              <ExactNavLink to="/our-story">Our Story </ExactNavLink>
            </li>
            <li className="nav-item text-truncate">
              <ExactNavLink to="/the-science">The Science</ExactNavLink>
            </li>
            <li className="nav-item text-truncate">
              <ExactNavLink to="/how-it-works">How It Works</ExactNavLink>
            </li>
            <li className="nav-item text-truncate">
              <ExactNavLink to="/pricing">Pricing</ExactNavLink>
            </li>
          </Scrollspy>
        </div>
        <div className={showNav ? "sidebar-nav active" : "sidebar-nav"}>
          <ul>
            <li>
              <Link to="/our-story">Our Story</Link>
            </li>
            <li>
              <a href="/the-science">The Science</a>
            </li>
            <li>
              <Link to="/how-it-works">How It Works</Link>
            </li>
            <li>
              <a href="/pricing">Pricing</a>
            </li>
          </ul>
        </div>
        <div className="gap-3 d-none d-md-none d-lg-flex">
          <a
            href={`${process.env.HOST_APP}login`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline-primary "
            style={{ minWidth: 158 }}
          >
            Host Login
          </a>
          <a
            href={`${process.env.WEB_APP}auth/login`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary "
            style={{ minWidth: 158 }}
          >
            Play Now
          </a>
        </div>
        <div className="d-flex  d-lg-none  justify-content-end align-items-center">
          <button
            className="navbar-toggler d-block"
            onClick={() => setShowNav(!showNav)}
            type="button"
          >
            {showNav ? (
              <span className="close">&times;</span>
            ) : (
              <span className="navbar-toggler-icon"></span>
            )}
          </button>
        </div>
      </div>
    </nav>
  )
}

Navbar.propTypes = {
  siteTitle: PropTypes.string,
  headerColor: PropTypes.string,
}

Navbar.defaultProps = {
  siteTitle: ``,
  headerColor: "#F2F8FC",
}

export default Navbar
